<p-dialog [(visible)]="displayModal" 
[modal]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false" [closeOnEscape]="false"
    class="confirmation-dialogue timer-modal">
    <ng-template pTemplate="header">Confirmation</ng-template>
    <div class="p-session-timeout-alert-message">        
        <div class="continue-session-head"><img alt="warningImage" class="warning-img" src="{{assetsUrl}}noun_Warning_3775442.png"> 
            <div class="continue-session-header">Are you still there?</div>
        </div>
        <div class="continue-session-text">We noticed that you've been inactive. To protect company information, you will be logged out of the system in <span class="timer-text"> {{ toHoursMinutesSeconds(sessionTimer.remainSeconds$ | async) }} </span> minutes.</div>
        <div class="continue-session">Do you want to continue your session?</div>                     
    </div>
    <ng-template pTemplate="footer">
        <div class="btnHolder">
            <button type="button" class="primaryBtn" (click)="onContinue()">
                <img alt="tickImage" src="{{assetsUrl}}tick (3).png">Continue</button>
            <button type="button" class="SecondaryBtn" (click)="onLogout()">
                <img alt="closeImage" src="{{assetsUrl}}close (1).png">Logout</button>
        </div>
    </ng-template>
</p-dialog>